import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import MarketingReveal from './MarketingReveal';

/**
 * Peerspace-style host / vendor recruitment close.
 */
const MarketingHostCtaBand = () => {
  return (
    <section className="bg-m-night px-4 py-20 text-m-on-dark sm:px-6 sm:py-28">
      <MarketingReveal className="mx-auto grid w-full max-w-6xl gap-10 lg:grid-cols-2 lg:items-center lg:gap-16">
        <div>
          <p className="mb-3 text-[11px] font-medium uppercase tracking-[0.14em] text-white/50">
            For vendors
          </p>
          <h2 className="marketing-section-title mb-4 max-w-lg text-m-on-dark">
            List your booth. Get booked.
          </h2>
          <p className="marketing-body-lg mb-8 max-w-md text-white/70">
            Join hundreds of dummy hosts already earning on VendaList — set your
            packages, open your calendar, and let the right parties find you.
          </p>
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link to="/register" className="marketing-btn marketing-btn-ghost gap-2">
              Become a vendor
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/how-it-works"
              className="inline-flex h-[var(--m-control-h)] items-center justify-center gap-2 rounded-full border border-white/25 px-6 text-sm font-medium text-white transition-colors hover:border-white/50"
            >
              How hosting works
            </Link>
          </div>
        </div>
        <div className="relative overflow-hidden rounded-[28px]">
          <img
            src="https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1400&q=80"
            alt=""
            className="aspect-[16/11] w-full object-cover"
            loading="lazy"
          />
        </div>
      </MarketingReveal>
    </section>
  );
};

export default MarketingHostCtaBand;
